






























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator } from 'vee-validate';

import { IPayment } from '@/interfaces/Payment';
import { EPaymentMethodTypes, ECardStep } from '@/helpers/enums';

import Field from '@/shared/components/Field/Field.vue';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Field,
  }
})
export default class CreditCardSelectForm extends Vue {
  @Prop()
  private readonly creditCardOptions: any;

  @Prop({ default: false })
  private readonly isSecondForm: boolean;

  @Prop()
  private readonly value: any;

  private validator = new Validator();

  private creditCardErrors: any = this.validator.errors;

  public $refs!: {
    observer: any,
    [x: string]: any;
  };

  @AppModule.Mutation
  private setPaymentMethodSelected: Function;

  @AppModule.Mutation
  private setStepFormSelected: Function;

  @AppModule.Mutation
  private setCardFirstDigits: Function;

  @AppModule.State
  private isCardSelectedLoading: boolean;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: IPayment;

  private get existCreditCard() {
    return this.creditCardOptions && this.creditCardOptions.length > 0;
  }

  private selectCreditCard(cardId: number | string) {
    const cardFirstDigits = this.creditCardOptions.find((option: any) => option.id === cardId);

    this.setCardFirstDigits(cardFirstDigits && cardFirstDigits.card_first_digits);
    this.setStepFormSelected(null);
    this.$emit('setCreditCard', cardId);

    this.$emit('input', cardId);

    this.validator.validate('cardSelected', cardId);
  }

  private emitShowNewCreditCardForm() {
    this.$emit('emitShowNewCreditCardForm', true);
    this.$emit('setCardStep', ECardStep.new);
  }

  public async validateForm() {
    const valid: boolean = await this.validator.validateAll({
      cardSelected: this.value,
    });

    return valid;
  }

  private mounted() {
    if (this.isSecondForm) {
      this.value && this.selectCreditCard(this.value);
    } else {
      this.value && this.selectCreditCard(this.payment.cards.main.id);
    }

    this.setPaymentMethodSelected(EPaymentMethodTypes.creditCard);

    this.value && this.setCardFirstDigits(this.value.card_first_digits);
  }


  private created() {
    this.validator.attach({
      name: 'cardSelected',
      rules: 'required'
    });
  }

  private destroyed() {
    this.validator.reset();
  }
}
